var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textcenter margin_top28vh"},[_c('img',{attrs:{"src":require("../../assets/404.png")}}),_vm._v(" "),_c('p',{staticClass:"fontsize_30"},[_vm._v("404")]),_vm._v(" "),_c('p',{staticClass:"color_99"},[_vm._v("您访问的页面不存在！")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-547a843f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/nofound.vue
// module id = AIZp
// module chunks = 1